import { FC } from 'react';
import { useInView } from 'react-intersection-observer';
// import { useTheme } from 'styled-components';

import { useI18nContext } from '../../../hooks/contexts/i18n.context';
import IllustrationHandIcon from '../../SvgCustom/svg/IllustrationHand';
import * as Styles from './summary.styles';

const NoTickets: FC = () => {
  const [ref, inView] = useInView({ triggerOnce : true, threshold : 0.1 });

  const { translate } = useI18nContext();
  // const theme = useTheme();
  return (
    <Styles.NoTicketsContainer ref={ref} $inView={inView} id="no-tickets-container">
      <img
        src={IllustrationHandIcon()}
        alt="illustrationHand" id="no-tickets-image"
      />
      <Styles.InfoContainer id="no-tickets-info-container">
        <h1 id="no-tickets-title">{translate(['STEPS', 'TXT16'])}</h1>
        <h2 id="no-tickets-subtitle">{translate(['STEPS', 'TXT17'])}</h2>
      </Styles.InfoContainer>
    </Styles.NoTicketsContainer>
  );
};

export default NoTickets;
